import { render, staticRenderFns } from "./todoList_old.vue?vue&type=template&id=35563aec&scoped=true"
import script from "./todoList_old.vue?vue&type=script&lang=js"
export * from "./todoList_old.vue?vue&type=script&lang=js"
import style0 from "./todoList_old.vue?vue&type=style&index=0&id=35563aec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35563aec",
  null
  
)

export default component.exports